import { WebData, webDataErrorSimple, webDataLoading, webDataNotAsked, webDataSuccess } from "@lvt/web-data";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ArchiveCabinet, fetchArchiveCabinets } from "@/api/archiveCabinets/archiveCabinets";


interface LiveUnitNavState {
    hidden: boolean;
    height: number;
    archiveCabinets: WebData<Array<ArchiveCabinet>>;
}

const initialState: LiveUnitNavState = {
    hidden: false,
    height: 0,
    archiveCabinets: webDataNotAsked(),
};

const liveUnitNavSlice = createSlice({
    name: "liveUnitNav",
    initialState,
    reducers: {
        setHidden(state, action: PayloadAction<boolean>) {
            state.hidden = action.payload;
        },
        setHeight(state, action: PayloadAction<number>) {
            state.height = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchArchiveCabinets.pending, (state) => {
                state.archiveCabinets = webDataLoading();
            })
            .addCase(fetchArchiveCabinets.fulfilled, (state, action) => {
                state.archiveCabinets = webDataSuccess(action.payload);
            })
            .addCase(fetchArchiveCabinets.rejected, (state, action) => {
                state.archiveCabinets = webDataErrorSimple({ message: JSON.stringify(action.payload) });
            });
    },
});

export const { setHidden, setHeight } = liveUnitNavSlice.actions;
export const liveUnitNavReducer = liveUnitNavSlice.reducer;
